export default {
  AccountingObjectCode: 'Mã đối tượng *',
  AccountingObjectType: 'Loại đối tượng',
  AccountingObjectName: 'Tên đối tượng *',
  Hamlet: 'Thôn xóm',
  ContactName: 'Người liên hệ',
  ContactTitle: 'Chức danh',
  Mobile: 'Mobile',
  QHNSCode: 'Mã QHNS',
  BankCode: 'Mã ngân hàng',
  BankName: 'Tên ngân hàng',
  BankAccount: 'Tài khoản ngân hàng',
  TaxCode: 'Mã số thuế',
  AccountingObjectInfo: 'Thông tin đối tượng',
  Fax: 'Fax',
  AccountingObjectContact: 'Thông tin người liên hệ',
  Email: 'Email',
  OtherInfo: 'Thông tin khác',
  Website: 'Website',
  Active: 'Theo dõi',
  AccountingObjectList: 'Danh sách đối tượng',
};
